/**
 * Combo Page Script
 * @description Script usado apenas pelo template starter da pagina de combo
 */

import { initGlobalComponents } from '../modules/global-components.js';

const initComboPage = () => {
    initGlobalComponents();
};

$(function() {
    initComboPage();
});

export default {
    init: initComboPage
};
